<template>
  <div class="row">
    <b-container fluid>
      <b-card>
        <b-overlay>
          <b-row>
            <b-col
              class="text-left"
            >
              <h3>Import văn bằng, chứng chỉ</h3>
            </b-col>
          </b-row>
          <b-row />
          <b-row>
            <b-col
              cols="3"
              class="text-left"
            >
              <b-form-group
                label="Phân loại"
                label-for="filter.credentialType"
              >
                <v-select
                  v-model="filter.credentialId"
                  :options="credentialsDropdown"
                  :reduce="option => option.value"
                  @input="onCredentialTypeChange"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              class="text-left"
            >
              <b-form-group
                label-for="file"
              >
                <template v-slot:label>
                  Chọn file văn bằng chứng chỉ: <span class="text-danger">*</span>
                </template>
                <b-form-file
                  ref="inputFileRef"
                  accept=".xls, .xlsx"
                  @change="importExcel"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="mainClassData.length > 0"
              class="text-right my-2"
            >
              <b-button
                variant="success"
                @click="importCredential"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="CheckSquareIcon" /> Import văn bằng, chứng chỉ
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem, BFormFile,
  BFormGroup, BFormInput, BFormSelect, BModal, BOverlay, BPagination, BRow,
  VBTooltip,
} from 'bootstrap-vue'
import SampleCertificateBlank from '@/views/certificate-blank/SampleCertificateBlank.vue'
import { VueGoodTable } from 'vue-good-table'
import { getUser } from '@/auth/utils'
import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import '@core/scss/vue/libs/vue-good-table.scss'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider } from 'vee-validate'
import CredentialStorageSave from '@/views/credential-storage/CredentialStorageSave.vue'
import PreviewCredential from '@/views/credential-storage/PreviewCredential.vue'
import ViewStorageFile from '@/views/credential-storage/ViewStorageFile.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'ImportCredentialStorage',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BFormFile,
    ViewStorageFile,
    PreviewCredential,
    BModal,
    ValidationProvider,
    BFormInput,
    SampleCertificateBlank,
    CredentialStorageSave,
    BDropdown,
    BDropdownItem,
    VueGoodTable,
    BButton,
    BButtonGroup,
    BCard,
    BCol,
    BContainer,
    BFormGroup,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BFormFile,
    vSelect,
  },
  data() {
    return {
      filter: {
        credentialType: 1,
        credentialId: null,
      },
      filterGetAll: {
        currentPage: 1,
        itemsPerPage: 1000,
      },
      mainClassData: [],
      dataExcel: [],
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      credentialsDropdown: 'dropdown/credentials',
    }),
  },
  async created() {
    const cUser = getUser()
    this.filter.organizationId = (cUser.orgId ? cUser.orgId : 0)
  },
  methods: {
    ...mapActions({
      addCredentialsStorage: 'credentialCreate/addCredentialsStorage',
    }),
    async onCredentialTypeChange(event) {
      this.filter.credentialType = event
    },
    async importCredential() {
      this.isLoading = true
      try {
        const responseAdd = await this.addCredentialsStorage(this.mainClassData)
        if (responseAdd) {
          const {
            isSuccessful,
            message,
          } = responseAdd
          if (isSuccessful) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    showToast(title, icon, variant, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
          text,
        },
      })
    },
    async importExcel(e) {
      if (this.filter.credentialId === null) {
        this.showToast('Hãy chọn phân loại', 'XCircleIcon', 'danger', '')
        this.resetInputFile()
        return
      }
      const { files } = e.target
      if (!files.length) {
        return
      } if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        // show err
      }
      if (files[0].name) {
        this.tenFile = files[0].name
      }
      this.readFile(files)
    },
    readFile(files) {
      const fileReader = new FileReader()
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          const wsName = workbook.SheetNames[0]
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsName], {
            header: 0,
            defval: '',
          })
          const excellist = []
          // Edit data
          if (ws.length > 0) {
            ws.forEach(item => {
              excellist.push(item)
            })
          } else {
            this.showToast('File không có dữ liệu', 'XCircleIcon', 'danger', '')
            return
          }
          if (
          // eslint-disable-next-line no-prototype-builtins
            !(excellist[0].hasOwnProperty('MA_SINH_VIEN')
              && excellist[0].hasOwnProperty('MA_LOP_CO_DINH')
              && excellist[0].hasOwnProperty('SO_QUYET_DINH')
              && excellist[0].hasOwnProperty('SO_HIEU_VAN_BANG')
              && excellist[0].hasOwnProperty('SO_VAO_SO')
              && excellist[0].hasOwnProperty('MA_HANG_TOT_NGHIEP')
              && excellist[0].hasOwnProperty('MA_NAM_HOC')
            )
          ) {
            this.showToast('File chưa đúng định dạng', 'XCircleIcon', 'danger', '')
            return
          }

          this.dataExcel = []
          // eslint-disable-next-line no-plusplus
          for (let k = 0; k < excellist.length; k++) {
            const item = excellist[k]
            const obj = {
              credentialId: this.filter.credentialId,
              studentCode: item.MA_SINH_VIEN || '',
              classCode: item.MA_LOP_CO_DINH || '',
              decisionNo: item.SO_QUYET_DINH || '',
              code: item.SO_HIEU_VAN_BANG || '',
              codeCredentialStorage: item.SO_VAO_SO || '',
              studyClassificationCode: item.MA_HANG_TOT_NGHIEP || '',
              yearCode: item.MA_NAM_HOC || '',
              status: 1,
            }
            this.dataExcel.push(obj)
          }
          this.mainClassData = this.dataExcel
        } catch (e) {
          alert(`Read failure!${e}`)
        }
      }
      fileReader.readAsBinaryString(files[0])
    },
    resetInputFile() {
      this.$refs.inputFileRef.reset()
    },
  },
}
</script>
